mutation UploadPrivateFile($input: UploadPrivateFileInput!) {
  file: uploadPrivateFile(input: $input) {
    id
    url
  }
}
